import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  fetchProcedureDetails,
  fetchSpecialityDoctors,
  fetchPatientStoryVideos,
  fetchProcedureFAQ,
  fetchSpecialityBlogs,
} from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import VideoTestimonials from "../components/VideoTestimonials";
import leftArrow from "../assets/images/doc-detail/leftwrrw.svg";
import rightArrow from "../assets/images/right-arrow.svg";
import useSeoWithParam from "../hooks/useSeoWithParam";
import SeoSpecialityHelmet from "../components/SeoSpecialityHelmet";
import SpecialBan from "../assets/images/speci-detail/specdetailban.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const ProcedureDetails = () => {
  const { specialitySlug, slug } = useParams();
  const navigate = useNavigate();
  const [procedure, setProcedure] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [doctors, setDoctors] = useState([]);
  const [patientStories, setPatientStories] = useState([]);
  const [faq, setFaq] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const seoData = useSeoWithParam(fetchProcedureDetails, slug);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await fetchProcedureDetails(slug);
        if (response && response.data) {
          setProcedure(response.data);
          
          const specId = response.data.speciality_id;
          if (specId) {
            const [doctorsRes, blogsRes] = await Promise.all([
              fetchSpecialityDoctors(specId),
              fetchSpecialityBlogs(specId)
            ]);

            if (doctorsRes && doctorsRes.data) {
              setDoctors(doctorsRes.data);
            }
            if (blogsRes && blogsRes.data) {
              setBlogs(blogsRes.data);
            }
          }

          const storiesRes = await fetchPatientStoryVideos();
          if (storiesRes && storiesRes.data) {
            setPatientStories(storiesRes.data);
          }

          const faqRes = await fetchProcedureFAQ(response.data.id);
          if (faqRes && faqRes.data) {
            setFaq(faqRes.data);
          }
        }
      } catch (error) {
        console.error("Error fetching procedure details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
    window.scrollTo(0, 0);
  }, [slug]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!procedure) {
    return <p>Procedure not found.</p>;
  }

  return (
    <>
      {seoData && <SeoSpecialityHelmet data={seoData} />}
      
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            {procedure.banner_img ? (
              <img 
                src={`${baseImage_path}/${procedure.banner_img.replace(/^\.\//, "")}`} 
                alt={procedure.name} 
              />
            ) : (
              <img src={SpecialBan} alt="Procedure Fallback" />
            )}
            <div className="ban-con">
              <h1>{procedure.name}</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="special-detail-target-sec mrgntop70">
        <div className="cust-container">
          <div className="special-detail-target-inner">
            <ul>
              <li style={{ cursor: "pointer" }}>
                <a 
                  href="#overviewid"
                  className={activeTab === "overview" ? "active" : ""} 
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("overview");
                    document.getElementById("overviewid")?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Overview
                </a>
              </li>
              {doctors.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#expert-cardiologistid">Doctors</a>
                </li>
              )}
              {blogs.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#ourblogs">Blogs</a>
                </li>
              )}
              {patientStories.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#patientstoriesid">Patient Stories</a>
                </li>
              )}
              {faq.length > 0 && (
                <li style={{ cursor: "pointer" }}>
                  <a href="#faqid">FAQ</a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </section>

      <section className="overview-sec mrgntop70" id="overviewid">
        <div className="cust-container">
          <div className="host-det specialDetailPad">
            {activeTab === "overview" && (
              <>
                <h4>Overview</h4>
                <div className="ck-content"
                  dangerouslySetInnerHTML={{
                    __html: procedure.overview || "No description available.",
                  }}
                />
              </>
            )}
          </div>
        </div>
      </section>

      {doctors.length > 0 && (
        <section className="our-expert-cardiologist-sec mrgntop70 margnbot90" id="expert-cardiologistid">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Our Team of Experts</h4>
            </div>
            <div className="row">
              {doctors.map((doctor) => (
                <div key={doctor.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                  <div className="oueextpert-cardiolo-item">
                    <div className="cardiolo-item-img">
                      <img
                        src={doctor.img_path ? `${baseImage_path}/${doctor.img_path.replace(/^\.\//, "")}` : `${baseImage_path}/images/default-doctor.png`}
                        alt={doctor.name}
                      />
                    </div>
                    <div className="cardiolo-itemdesc">
                      <div className="drs-design">
                        <span>{doctor.speciality_name || procedure.speciality_name}</span>
                        <button
                          onClick={() => navigate(`/doctor/${doctor.slug}`)}
                          style={{
                            background: "transparent",
                            color: "#0ca854",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        >
                          View Profile
                        </button>
                      </div>
                      <div className="drs-title">
                        <h4>{doctor.name_prefix} {doctor.name}</h4>
                      </div>
                      <p>
                        Total Experience - {doctor.experience ? doctor.experience.replace(/\+/g, '') + '+' : 'N/A'} Years
                      </p>
                      <div className="drs-bookapp-cta common-roundcta">
                        <button
                          className="btnhv"
                          onClick={() => navigate(`/doctor/${doctor.slug}`)}
                        >
                          Book Appointment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {blogs.length > 0 && (
        <section className="our-blogs-sec mrgntop70 margnbot90" id="ourblogs">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Our Blogs</h4>
            </div>
            <div className="blog-slider-container">
              <div className="custom-swiper-prev">
                <img src={leftArrow} alt="Previous" />
              </div>
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                  nextEl: ".custom-swiper-next",
                  prevEl: ".custom-swiper-prev",
                }}
                slidesPerView={3}
                spaceBetween={30}
                loop={true}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
              >
                {blogs.map((blog) => (
                  <SwiperSlide key={blog.id}>
                    <div className="our-video-sec-item">
                      <div className="our-video-img">
                        <img
                          src={blog.featured_img ? `${baseImage_path}/${blog.featured_img.replace(/^\.\//, "")}` : "default-blog.jpg"}
                          alt={blog.title}
                        />
                        <div className="our-vdo-categ">
                          <span>{blog.category || "Uncategorized"}</span>
                        </div>
                        <div className="our-video-desc our-vdo-desc-cta-green">
                          <span>{new Date(blog.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</span>
                          <p>{blog.title}</p>
                          <a href={`/blogs/${blog.slug}`}>Read More</a>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="custom-swiper-next">
                <img src={rightArrow} alt="Next" />
              </div>
            </div>
          </div>
        </section>
      )}

      {patientStories.length > 0 && (
        <section className="patient-story-sec mrgntop70 margnbot90" id="patientstoriesid">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Patient Stories</h4>
            </div>
            <VideoTestimonials videos={patientStories} />
          </div>
        </section>
      )}

      {faq.length > 0 && (
        <section className="faq-sec margnbot90" id="faqid">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Frequently Asked Questions</h4>
            </div>
            <div className="faqsec-inner">
              <div className="accordion" id="procedure-faqs">
                {faq.map((item, index) => (
                  <div className="card" key={item.id}>
                    <div className="card-header" id={`heading${item.id}`}>
                      <button
                        className="collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapse${item.id}`}
                        aria-expanded="false"
                        aria-controls={`collapse${item.id}`}
                      >
                        {item.question}
                      </button>
                    </div>
                    <div
                      id={`collapse${item.id}`}
                      className="collapse"
                      aria-labelledby={`heading${item.id}`}
                      data-parent="#procedure-faqs"
                    >
                      <div className="card-body">
                        <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ProcedureDetails;
